import { gate } from 'hub-http/gates';
export const GATES = {
  MARKETING_STUDIO_HOME: gate('MarketingStudio:Studio2.0:Home'),
  CHANGES_REQUESTED_AND_STAGES: gate('ProductApprovals::ChangesRequestedAndStages'),
  AGENT_APPROVER: gate('ProductApprovals::AgentApprover'),
  PAGE_EDITOR_AI_EDITING_EXPERIMENT: gate('PageEditorAIEditingExperiment'),
  EDITOR_V2_APPROVALS: gate('EdExt::EditorV2::Approvals'),
  AGENT_IMPLEMENTING_REQUESTED_CHANGES: gate('ProductApprovals::AgentImplementingRequestedChanges'),
  // Controls reading the new generic (V2) unified events in the sidepanel
  // instead of the legacy per-type (V1) events.
  UE_GENERIC: gate('ProductApprovals::UE::Generic'),
  // Quotes/Commerce team-based-approvals beta relies on the approval redesign,
  // so this gate also opts users into the redesign. See
  // useHasSeqReqChangesRedesign.
  QUOTES_TEAM_BETA: gate('commerce:qmgmt:TeamBasedApprovals')
};